import { SECTION_IDS } from '../../../core/constants/navigation';
import Reveal from '../../../common/components/Reveal/Reveal';
import ResponsiveImage from '../../../common/components/ResponsiveImage/ResponsiveImage';
import SectionHeading from '../../../common/components/SectionHeading/SectionHeading';

import '../styles/solutions.css';

const SOLUTIONS = [
    {
        image: 'solution-events',
        title: 'Coberturas de eventos',
        text: 'Registramos lanzamientos, foros y ruedas de prensa con equipos profesionales.',
        tag: 'Audiovisual',
        alt: 'Público asistiendo a una conferencia en un auditorio',
        area: 'events',
    },
    {
        image: 'solution-streaming',
        title: 'Streaming y contenido en vivo',
        text: 'Montamos transmisiones estables para que tu audiencia te siga en tiempo real.',
        tag: 'Web y audiovisual',
        alt: 'Creadora de contenido transmitiendo en vivo con micrófono y audífonos',
        area: 'streaming',
    },
    {
        image: 'solution-podcast',
        title: 'Podcast y radio',
        text: 'Producción, edición y distribución de formatos sonoros.',
        tag: 'Audiovisual',
        alt: 'Micrófono de estudio frente a una consola de grabación',
        area: 'podcast',
    },
    {
        image: 'solution-news',
        title: 'Portales de noticias',
        text: 'Sitios veloces, optimizados para SEO y pensados para publicar rápido.',
        tag: 'Desarrollo web',
        alt: 'Máquina de escribir con una hoja que dice News',
        area: 'news',
    },
    {
        image: 'solution-social',
        title: 'Redes y comunidades',
        text: 'Gestión de comunidades y pauta que convierte.',
        tag: 'Marketing',
        alt: 'Teléfono móvil con aplicaciones de redes sociales',
        area: 'social',
    },
    {
        image: 'solution-coverage',
        title: 'Spots y piezas comerciales',
        text: 'Ideas creativas que se convierten en piezas memorables para tu marca y tus anunciantes.',
        tag: 'Audiovisual',
        alt: 'Claqueta de cine sostenida frente a un paisaje desértico',
        area: 'spots',
    },
];

export default function Solutions() {
    return (
        <section id={SECTION_IDS.SOLUTIONS} className="solutions" aria-labelledby="solutions-title">
            <div className="layout-container">
                <SectionHeading
                    headingId="solutions-title"
                    eyebrow="Soluciones"
                    title="Lo que hacemos posible para tu audiencia"
                    lead="Formatos y plataformas que combinamos según los objetivos de cada medio y cada marca."
                />

                <ul className="solutions__grid">
                    {SOLUTIONS.map((solution, index) => (
                        <Reveal
                            as="li"
                            key={solution.title}
                            delay={(index % 3) * 100}
                            className={`solutions__tile solutions__tile--${solution.area}`}
                        >
                            <ResponsiveImage
                                name={solution.image}
                                sizes="(min-width: 1024px) 760px, (min-width: 640px) 50vw, 92vw"
                                width={1200}
                                height={800}
                                className="solutions__image"
                                alt={solution.alt}
                            />
                            <div className="solutions__caption">
                                <span className="solutions__tag">{solution.tag}</span>
                                <h3 className="solutions__title">{solution.title}</h3>
                                <p className="solutions__text">{solution.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </ul>
            </div>
        </section>
    );
}
